
// @ is an alias to /src

import { defineComponent, PropType } from 'vue';
import { ITextarea } from '.';

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<ITextarea>,
      required: true,
    },
    value: String,
  },

  setup(props, { emit }) {
    const updateValue = (value: string | number) => {
      emit('input', value);
      if (props.config.error) {
        props.config.error = false;
        props.config.message = undefined;
      }
      if (props.config.onInput) {
        props.config.onInput(value);
      }
    };
    return { updateValue };
  },
});
